module.exports = __webpack_public_path__ + "static/media/1009288.9961fd44.png";